// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  base_api_uri: 'https://dev-api.blueparking.co.th',
  api_version: 'v1',
  auth_url: `https://dev-api.blueparking.co.th/uaa/oauth/token`,
  client_id: '0291650777017771762870380918',
  grant_type: 'password',
  client_secret: '123456'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts